import React from "react";
import Landing from "../components/Checkout/Landing";
import Card from "../components/Checkout/Card";
import MainLayouts from "../layout/MainLayouts";

const CheckOutPage = () => {
  return (
    <MainLayouts>
      <Landing />
      <Card />
    </MainLayouts>
  );
};

export default CheckOutPage;
